import React from "react";

const Tags = () => {
  const list = [
    "Business",
    "Digital",
    "IT Solution",
    "Technology",
    "Agency",
    "Digital",
  ];
  return (
    <div className="flex flex-wrap gap-2 md:gap-3">
      {list.map((tag, index) => (
        <button
          key={index}
          className="bg-white py-2.5 md:py-3.5 px-4 md:px-6 text-sm rounded-full leading-[1.6] text-custom-black font-normal">
          {tag}
        </button>
      ))}
    </div>
  );
};

export default Tags;
